import { render } from "./MyOpponents.vue?vue&type=template&id=2c46e4ec&ts=true"
import script from "./MyOpponents.vue?vue&type=script&lang=ts"
export * from "./MyOpponents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__